import type {
  TripAddTripLegWrite,
} from 'src/common/external/bambi-api/tripsApi';

import type { AddTripFormValues } from '../FormValues';
import {
  buildExistingTripPayload,
  buildNewTripPayload,
} from './adaptFormValuesHelpers';

export function adaptFormValuesToAddTripLeg(
  formValues: AddTripFormValues
): TripAddTripLegWrite {
  const originalTrip: TripAddTripLegWrite['original_trip'] =
    buildExistingTripPayload(formValues.trips[0], formValues);

  const returnTrip: TripAddTripLegWrite['return_trip'] = buildNewTripPayload(
    formValues.trips[1],
    formValues
  );

  return {
    original_trip: originalTrip,
    return_trip: returnTrip,
  };
}
